<template>
  <el-row :gutter="10" v-if="!isZeenow">
    <el-col :span="24">
      <div class="table">
        <ul class="list-unstyled timeline payment-timeline">
          <li v-if="getPurchaseOrder.payment.status == 'paid'">
            <div class="block">
              <div class="block_content">
                <h2 class="title last">PO is paid</h2>
              </div>
            </div>
          </li>
          <li v-for="(payment, index) in getOrderedPaymentList" :key="payment.id">
            <div class="block">
              <div class="block_content" style="position: relative;">
                <h2
                  class="title"
                  :class="{
                    pending: payment.status == 'pending',
                    'pending-confirmation': payment.status == 'pending-confirmation',
                    rejected: payment.status == 'rejected',
                    confirmed: payment.status == 'confirmed'
                }"
                >
                  <span style="text-transform:uppercase;">
                    Payment #{{ getOrderedPaymentList.length - index }} -
                    <el-tag v-if="payment.status == 'pending'" type="warning">Pending</el-tag>
                    <el-tag
                      v-else-if="payment.status == 'pending-confirmation'"
                      type="primary"
                    >Pending confirmation</el-tag>
                    <el-tag
                      v-else
                      :type="payment.acknowledgement ? 'success' : 'danger'"
                    >{{ payment.acknowledgement ? 'Confirmed' : 'Rejected' }}</el-tag>
                    <el-button
                      v-if="(checkUserGroup(getGroups.FACTORY) || checkUserGroup(getGroups.MANAGE)) && payment.status == 'confirmed'"
                      :plain="true"
                      type="text"
                      size="small"
                      @click="openConfirmReset(payment.id, index)"
                    >UNDO</el-button>
                    <small>
                      (
                      <span>{{ payment.updated | moment("from", "now") }}</span>
                      <span
                        v-if="payment.updatedBy"
                      >by {{ payment.updatedBy.firstName }} {{ payment.updatedBy.lastName }}</span>
                      )
                    </small>
                  </span>
                </h2>
                <br />
                <div v-if="payment.status == 'rejected' || payment.status == 'confirmed' ">
                  <el-card class="box-card" v-loading="isUndoLoading">
                    <div slot="header" class="clearfix">
                      <h5
                        style="text-transform:uppercase;margin: 0;display:inline-block;"
                        :class="payment.status == 'confirmed' ? 'text-confirmation' : 'text-rejected'"
                      >
                        {{ payment.status == 'confirmed' ? 'Confirmed' : 'Rejected' }}
                        <span
                          v-if="payment.acknowledgementObservation"
                        >Message</span>
                      </h5>
                      <span class="pull-right">
                        {{ payment.acknowledgementAt | moment("from", "now") }}
                        <span
                          v-if="payment.acknowledgementBy"
                        >by {{ payment.acknowledgementBy.firstName }} {{ payment.acknowledgementBy.lastName }}</span>
                      </span>
                    </div>
                    <div v-if="payment.acknowledgementObservation">
                      <p>{{ payment.acknowledgementObservation }}</p>
                    </div>
                    <div
                      v-if="(checkUserGroup(getGroups.FINANCIAL) || checkUserGroup(getGroups.MANAGE)) && payment.status == 'rejected'"
                      style="margin-top: 20px;"
                    >
                      <el-row :gutter="10">
                        <el-col :span="24">
                          <el-button
                            class="btn-block"
                            type="success"
                            @click="openPayDialog(payment.id)"
                          >Retry</el-button>
                        </el-col>
                      </el-row>
                    </div>
                  </el-card>
                  <br />
                </div>
                <!-- CONFIRM OR REJECT CARD  -->
                <el-card style="margin-bottom: 20px;" v-if="payment.status !== 'pending'">
                  <div slot="header" class="clearfix">
                    <h5 style="text-transform:uppercase;margin: 0;display:inline-block;">
                      <strong>Payment info</strong>
                    </h5>
                    <span class="pull-right">
                      <strong>DUE:</strong>
                      <span>{{ payment.due | moment('DD/MM/YYYY') }}</span>
                      <el-button
                        v-if="checkUserGroup(getGroups.FACTORY) || checkUserGroup(getGroups.MANAGE)"
                        :plain="true"
                        type="text"
                        size="small"
                        @click="openEditDueDialog(payment.id, index)"
                      >Edit</el-button>
                    </span>
                  </div>
                  <div class="card-content">
                    <p>
                      <span class="info">Amount Paid:</span>
                      <span class="pull-right">{{ payment.amount | currency }}</span>
                    </p>
                    <hr v-if="payment.payedBy" />
                    <p v-if="payment.payedBy">
                      <span class="info">Paid by:</span>
                      <span
                        class="pull-right"
                      >{{ payment.payedBy.firstName }} {{ payment.payedBy.lastName }}</span>
                    </p>
                    <hr v-if="payment.payedAt" />
                    <p v-if="payment.payedAt">
                      <span class="info">Paid at:</span>
                      <el-tooltip :content="dateTimezoneUser(payment.payedAt)" placement="top">
                        <span class="pull-right">{{ dateTimezoneChina(payment.payedAt, true) }}</span>
                      </el-tooltip>
                    </p>
                    <hr v-if="payment.receipt" />
                    <p v-if="payment.receipt">
                      <span class="info">Receipt:</span>
                      <span class="pull-right">
                        <a
                          :href="payment.receipt"
                          :download="payment.receipt"
                          target="_blank"
                          class="pull-right"
                        >
                          <span class="fa fa-paperclip"></span> Download
                        </a>
                      </span>
                    </p>
                    <hr v-if="payment.payerObservation" />
                    <p class="excerpt" v-if="payment.payerObservation">
                      <span class="info">Payment obs:</span>
                      <br />
                    </p>
                    <p class="well" v-if="payment.payerObservation">{{ payment.payerObservation }}</p>
                    <div
                      v-if="payment.status == 'pending-confirmation' && (checkUserGroup(getGroups.FACTORY) || checkUserGroup(getGroups.MANAGE))"
                      style="margin-top: 20px;"
                    >
                      <el-row :gutter="10">
                        <el-col :span="12">
                          <el-button
                            class="btn-block"
                            type="success"
                            @click="openConfirmPaymentDialog(payment.id)"
                          >Confirm Payment</el-button>
                        </el-col>
                        <el-col :span="12">
                          <el-button
                            :plain="true"
                            class="btn-block"
                            type="danger"
                            @click="openRejectPaymentDialog(payment.id)"
                          >Not right?</el-button>
                        </el-col>
                      </el-row>
                    </div>
                  </div>
                </el-card>
                <!-- /CONFIRM OR REJECT CARD  -->
                <!-- PAY CARD  -->
                <el-card style="margin-bottom: 20px;" v-if="payment.status == 'pending'">
                  <div slot="header" class="clearfix">
                    <h5 style="text-transform:uppercase;margin: 0;display:inline-block;">
                      <strong>Payment info</strong>
                    </h5>
                    <span class="pull-right">
                      <strong>DUE:</strong>
                      <span>{{ payment.due | moment('DD/MM/YYYY') }}</span>
                      <el-button
                        v-if="checkUserGroup(getGroups.FACTORY) || checkUserGroup(getGroups.MANAGE)"
                        :plain="true"
                        type="text"
                        size="small"
                        @click="openEditDueDialog(payment.id, index)"
                      >Edit</el-button>
                    </span>
                  </div>
                  <div class="card-content">
                    <p>
                      <span class="info">Created at:</span>
                      <el-tooltip :content="dateTimezoneUser(payment.created)" placement="top">
                        <span class="pull-right">{{ dateTimezoneChina(payment.created, true) }}</span>
                      </el-tooltip>
                    </p>
                    <div
                      v-if="checkUserGroup(getGroups.FINANCIAL) || checkUserGroup(getGroups.MANAGE)"
                      style="margin-top: 20px;"
                    >
                      <el-row :gutter="10">
                        <el-col :span="24">
                          <el-button
                            class="btn-block"
                            type="success"
                            @click="openPayDialog(payment.id)"
                          >Pay</el-button>
                        </el-col>
                      </el-row>
                    </div>
                  </div>
                </el-card>
                <!-- /PAY CARD  -->
              </div>
            </div>
          </li>
          <li>
            <div class="block">
              <div class="block_content">
                <h2 class="title first">Total Amount: {{ item.amount | currency }}</h2>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </el-col>
    <el-dialog
      @close="resetForm('confirmForm')"
      title="Add a confirmation observation"
      :visible.sync="confirmPaymentDialog"
    >
      <el-form :model="confirmForm" ref="confirmForm">
        <el-form-item prop="confirmationPaymentObs">
          <el-input
            type="textarea"
            :rows="3"
            placeholder="Add an observation to the payment confirmation"
            :disabled="isConfirmPaymentLoading"
            v-model="confirmForm.confirmationPaymentObs"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="confirmPaymentDialog = false">Cancel</el-button>
        <el-button
          type="success"
          :loading="isConfirmPaymentLoading"
          @click="confirmPayment('confirmForm')"
        >Confirm payment</el-button>
      </span>
    </el-dialog>
    <el-dialog
      @close="resetForm('rejectForm')"
      title="Explain the problem with the payment"
      :visible.sync="rejectPaymentDialog"
    >
      <el-form :model="rejectForm" ref="rejectForm">
        <el-form-item
          :rules="[
            { required: true, message: 'Observation is required', trigger:'change'}
          ]"
          prop="rejectPaymentObs"
        >
          <el-input
            type="textarea"
            :rows="3"
            :disabled="isRejectPaymentLoading"
            placeholder="Add an observation to explain the payment's problem"
            v-model="rejectForm.rejectPaymentObs"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="rejectPaymentDialog = false">Cancel</el-button>
        <el-button
          type="success"
          :loading="isRejectPaymentLoading"
          @click="rejectPayment('rejectForm')"
        >Reject payment</el-button>
      </span>
    </el-dialog>
    <el-dialog
      @close="resetForm('payForm')"
      title="Add payment"
      :visible.sync="payDialog"
      class="add-payment-dialog"
    >
      <el-form
        v-loading="isAddPaymentLoading"
        element-loading-text="Sending payment..."
        :model="payForm"
        :rules="payFormRules"
        label-position="top"
        ref="payForm"
        id="payForm"
        class="add-payment-form"
      >
        <el-form-item
          label="Attach the receipt:"
          :label-width="payDialogLabelWidth"
          prop="fileList"
        >
          <div class="el-upload el-upload--text">
            <el-button
              class="add-receipt-button"
              :disabled="isAddPaymentLoading"
              icon="document"
              type="default"
              :plain="true"
              @click.native="fireClickFile('paymentFileInput')"
            >Choose file</el-button>
            <br />
            <span v-if="getFileName">
              <strong>File selected:</strong>
              {{ getFileName }}
              <el-button size="mini" icon="close" @click="removeFile('paymentFileInput')"></el-button>
            </span>
            <input
              type="file"
              name="file"
              @change="getFile"
              ref="paymentFileInput"
              class="el-upload__input"
            />
          </div>
        </el-form-item>
        <el-form-item :label="labelAmount" :label-width="payDialogLabelWidth" prop="amountPaid">
          <div class="input-group masked-input-radius">
            <span class="input-group-addon">$</span>
            <masked-input
              type="text"
              name="phone"
              class="el-input__inner"
              v-model="payForm.amountPaid"
              :mask="getMask"
              :guide="false"
              :disabled="isAddPaymentLoading"
              placeholder-char="#"
              placeholder="Insert the amount paid in the receipt"
            ></masked-input>
          </div>
        </el-form-item>
        <el-form-item
          prop="paymentReceiptObservation"
          label="Observation:"
          :label-width="payDialogLabelWidth"
        >
          <el-input
            type="textarea"
            :rows="3"
            :disabled="isAddPaymentLoading"
            placeholder="Add an observation to the payment"
            v-model="payForm.paymentReceiptObservation"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="payDialog = false">Cancel</el-button>
        <el-button
          type="success"
          :loading="isAddPaymentLoading"
          @click="submitPayment('payForm')"
        >Send</el-button>
      </span>
    </el-dialog>
    <el-dialog :title="editDueTitle" :visible.sync="editDueDialog">
      <el-form :model="editDueForm" :rules="editDueRules" ref="editDueForm">
        <el-form-item label="New due date" :label-width="formLabelWidth" prop="due">
          <el-date-picker
            v-model="editDueForm.due"
            type="date"
            ref="due"
            format="dd/MM/yyyy"
            :disabled="isEditDueLoading"
            placeholder="Select a new due date"
          ></el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDueDialog = false">Cancel</el-button>
        <el-button
          type="success"
          :loading="isEditDueLoading"
          @click="submitNewDue('editDueForm')"
        >Confirm</el-button>
      </span>
    </el-dialog>
  </el-row>
</template>

<script>
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import { mapGetters } from "vuex";
import * as groups from "@/js/user-groups";
import currency from "@/filters/currency";
import {
  getDateTimezoneUser,
  getDateTimezoneChina
} from "@/helpers/user-timezone";

export default {
  props: {
    item: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      selectedPayment: null,
      editDueDialog: false,
      selectedPaymentIndex: null,
      formLabelWidth: "120px",
      isEditDueLoading: false,
      isAddPaymentLoading: false,
      isConfirmPaymentLoading: false,
      isRejectPaymentLoading: false,
      isUndoLoading: false,
      editDueForm: {
        due: ""
      },
      editDueRules: {
        due: [{ required: true, message: "Due is required" }]
      },
      hasActivities: true,
      hasPaymentDue: false,
      paymentDueDate: "",
      paymentDueDate2: "",
      paymentReceiptObservation: "",
      paymentObs: "",
      payDialog: false,
      confirmPaymentDialog: false,
      rejectPaymentDialog: false,
      selectedPaymentId: null,
      payForm: {
        paymentReceiptObservation: "",
        amountPaid: "",
        fileList: []
      },
      payFormRules: {
        fileList: [{ required: true, message: "Receipt is required" }],
        amountPaid: [{ required: true, message: "Amount paid is required" }]
      },
      confirmForm: {
        confirmationPaymentObs: ""
      },
      rejectForm: {
        rejectPaymentObs: ""
      },
      payDialogLabelWidth: "140px"
    };
  },
  computed: {
    ...mapGetters({
      getPayments: "getPayments",
      getHasPaymentDue: "getHasPaymentDue",
      getUser: "getUser",
      isZeenow: "isZeenow"
    }),
    getMask() {
      return createNumberMask({
        prefix: "",
        allowDecimal: true
      });
    },
    getFileName() {
      return this.payForm.fileList.name;
    },
    getGroups() {
      return groups;
    },
    getOrderedPaymentList() {
      function sortById(a, b) {
        const id1 = a.id;
        const id2 = b.id;
        return id1 > id2 ? -1 : id1 < id2 ? 1 : 0; // eslint-disable-line
      }
      return this.getPurchaseOrder.payment.payments.slice().sort(sortById);
    },
    getPurchaseOrder() {
      return this.$store.getters.getPOItem;
    },
    getTotalPaid() {
      let paymentsTotal = 0;
      for (
        let i = 0;
        i < this.getPurchaseOrder.payment.payments.length;
        i += 1
      ) {
        if (this.getPurchaseOrder.payment.payments[i].status === "confirmed") {
          paymentsTotal += parseFloat(
            this.getPurchaseOrder.payment.payments[i].amount
          );
        }
      }
      if (this.item.amount - paymentsTotal < 0) {
        return 0;
      }
      const formattedCurrency = this.item.amount - paymentsTotal;
      return currency(formattedCurrency);
    },
    labelAmount() {
      return `Amount paid: (Total left: ${this.getTotalPaid})`;
    },
    editDueTitle() {
      return "Edit due date";
    }
  },
  methods: {
    dateTimezoneUser(date) {
      return getDateTimezoneUser(date);
    },
    dateTimezoneChina(date, showTime) {
      return getDateTimezoneChina(date, showTime);
    },
    fireClickFile(ref) {
      this.$refs[ref].click();
    },
    checkUserGroup(group) {
      if (process.env.NODE_ENV === "production") {
        for (let i = 0; i < this.getUser.groups.length; i += 1) {
          if (
            this.getUser.groups[i].name.toLowerCase() === group.toLowerCase()
          ) {
            return true;
          }
        }
      }
      return true;
    },
    addPaymentDue() {
      if (this.paymentDueDate !== "" && this.paymentObs !== "") {
        const paymentDue = JSON.stringify(this.paymentDueDate);
        const cleanDate = paymentDue
          .substring(0, paymentDue.indexOf("T"))
          .replace('"', "");
        let paymentObj = {};
        if (this.paymentDueDate2 !== "") {
          const paymentDue2 = JSON.stringify(this.paymentDueDate2);
          const cleanDate2 = paymentDue2
            .substring(0, paymentDue2.indexOf("T"))
            .replace('"', "");
          paymentObj = {
            due: cleanDate,
            due2: cleanDate2,
            observation: this.paymentObs
          };
        } else {
          paymentObj = { due: cleanDate, observation: this.paymentObs };
        }
        this.$store.dispatch("setPaymentDue", {
          poId: this.item.id,
          paymentId: this.item.payment.id,
          paymentDue: paymentObj
        });
      } else {
        this.$message.warning("Payment due date and observation are required.");
      }
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      if (formName === "payForm") {
        this.$refs.paymentFileInput.value = "";
      }
    },
    submitPayment(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          const formData = new FormData();
          formData.append("amount", this.payForm.amountPaid.replace(/,/g, ""));
          formData.append(
            "payerObservation",
            this.payForm.paymentReceiptObservation
          );
          formData.append("receipt", this.payForm.fileList);
          formData.append("fullResponse", true);
          this.$store.dispatch("setPayment", {
            poId: this.item.id,
            paymentId: this.selectedPaymentId,
            payment: formData,
            scope: this
          });
          this.payForm.paymentReceiptObservation = "";
          this.payForm.fileList = [];
          this.payForm.amountPaid = "";
          // this.payDialog = false
        }
        return false;
      });
    },
    getFile(e) {
      this.payForm.fileList = e.target.files[0]; // eslint-disable-line
    },
    removeFile(ref) {
      this.$refs[ref].value = "";
      this.payForm.fileList = [];
    },
    openConfirmPaymentDialog(id) {
      this.confirmPaymentDialog = true;
      this.selectedPaymentId = id;
    },
    openRejectPaymentDialog(id) {
      this.rejectPaymentDialog = true;
      this.selectedPaymentId = id;
    },
    openPayDialog(id) {
      this.payDialog = true;
      this.selectedPaymentId = id;
    },
    confirmPayment(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          const acknowledgementObservation = {
            acknowledgementObservation: this.confirmForm.confirmationPaymentObs
          };
          this.$store.dispatch("sendPaymentConfirmation", {
            poId: this.item.id,
            paymentId: this.selectedPaymentId,
            data: acknowledgementObservation,
            scope: this
          });
          this.confirmForm.confirmationPaymentObs = "";
        }
        return false;
      });
    },
    openConfirmReset(id) {
      this.$confirm(
        "Are you sure you want to undo the payment confirmation?",
        "Warning",
        {
          confirmButtonText: "Yes, undo",
          cancelButtonText: "Cancel",
          type: "warning"
        }
      )
        .then(() => {
          this.$store.dispatch("sendResetConfirmation", {
            poId: this.item.id,
            paymentId: id,
            scope: this
          });
        })
        .catch(() => false);
    },
    rejectPayment(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          const acknowledgementObservation = {
            acknowledgementObservation: this.rejectForm.rejectPaymentObs
          };
          this.$store.dispatch("sendPaymentRejection", {
            poId: this.item.id,
            paymentId: this.selectedPaymentId,
            data: acknowledgementObservation,
            scope: this
          });
        }
        return false;
      });
    },
    openEditDueDialog(id, index) {
      this.editDueDialog = true;
      this.selectedPayment = id;
      this.selectedPaymentIndex = index;
    },
    submitNewDue(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          const newDueDate = JSON.stringify(this.editDueForm.due);
          const cleanDue = newDueDate
            .substring(0, newDueDate.indexOf("T"))
            .replace('"', "");
          const paymentObj = {
            payment: {
              payments: [
                {
                  id: this.selectedPayment,
                  due: cleanDue
                }
              ]
            }
          };
          this.$store.dispatch("setPaymentDue", {
            poId: this.item.id,
            paymentDue: paymentObj,
            scope: this
          });
        }
        return false;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.timeline h2.title.first:before {
  top: 30px;
  background: #13ce66;
  border-color: #13ce66;
}
.timeline h2.title.last:before {
  top: -21px;
  background: #13ce66;
  border-color: #13ce66;
}
.timeline h2.title.pending:before {
  background: #f7ba2a;
  border-color: #f7ba2a;
}
.timeline h2.title.pending-confirmation:before {
  background: #20a0ff;
  border-color: #20a0ff;
}
.timeline h2.title.rejected:before {
  background: #ff4949;
  border-color: #ff4949;
}
.timeline h2.title.confirmed:before {
  background: #13ce66;
  border-color: #13ce66;
}
.btn-full {
  width: 100%;
}
.el-card__header {
  padding: 0 20px;
}
.text-confirmation {
  color: #13ce66;
}
.text-rejected {
  color: #ff4949;
}
.card-content {
  width: 100%;
  p:first-child {
    margin-top: 10px;
  }
  .info {
    text-transform: uppercase;
  }
}
.payment-due-date {
  max-width: 400px;
  margin: 35px auto;
  .el-button {
    width: 100%;
  }
}
.el-upload {
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/purchase-orders/purchase-order/partials/payment-partials/PoPaymentsTimeline.vue